import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import Carousel from 'components/ui/Carousel/Carousel'
import BackNextModal from 'components/modals/BackNextModal/BackNextModal'
import { ContentLoader } from 'components/_new/ui'

import messages from './messages'
import s from './ChooseGiftCardSkinModal.scss'


const carouselOptions = {
  className: s.carousel,
  dots: true,
  speed: 200,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  arrows: true,
  swipe: true,
  touchMove: true,
}


class ChooseGiftCardSkinModal extends Component {

  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      img: PropTypes.string.isRequired,
    })).isRequired,
    data: PropTypes.shape({
      onNext: PropTypes.func.isRequired,
      onBack: PropTypes.func.isRequired,
    }),
    name: PropTypes.string,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    name: constants.modals.gifts.ChooseGiftCardSkin,
  }

  selectedSkinIndex = 0

  componentDidMount() {
    actions.view.giftCardPage.fetchCardSkins()
  }

  handleClose = () => {
    const { name, onClose } = this.props

    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  handleChooseItem = (index) => {
    this.selectedSkinIndex = index
  }

  goBack = () => {
    const { data: { onBack } } = this.props

    this.handleClose()
    onBack()
  }

  goNext = () => {
    const { items, data: { onNext } } = this.props

    const selectedSkin = items[this.selectedSkinIndex]

    if (selectedSkin) {
      this.handleClose()
      onNext(selectedSkin)
    }
  }

  render() {
    const { name, items, isFetching } = this.props

    return (
      <BackNextModal
        className={s.chooseGiftCardSkinModal}
        dataTestId={constants.testIds.modal.chooseGiftCardSkinModal}
        name={name}
        nextButtonId="giftChooseTypeButton"
        onClose={this.handleClose}
        onBack={this.goBack}
        onNext={this.goNext}
      >
        <FormattedMessage className={s.title} tag="div" {...messages.title} />
        {
          isFetching ? (
            <ContentLoader />
          ) : (
            <Carousel
              className={s.carouselContainer}
              options={carouselOptions}
              afterChange={this.handleChooseItem}
            >
              {
                items.map(({ id, img }) => (
                  <div key={id} className={s.pictureContainer}>
                    <img className={s.picture} alt="card-skin" src={img} />
                  </div>
                ))
              }
            </Carousel>
          )
        }
      </BackNextModal>
    )
  }
}


export default connect({
  items: 'view.giftCardPage.cardSkins.items',
  isFetching: 'view.giftCardPage.cardSkins.isFetching',
})(ChooseGiftCardSkinModal)
